import { useContext, useEffect, useState } from "react"
import { Dimensions, Platform, ScaledSize } from "react-native"
import { isSafari } from "react-device-detect"
import { AppContext } from "@contexts"
import { EmbeddedState } from "@contexts/AppProvider/AppReducer"

const getPlatformSpecificScreen = () => {
    if (Platform.OS === "web") return "window"
    else if (Platform.OS === "android") return "window"
    else if (isSafari) return "window"
    else return "screen"
}

const getPlatformSpecificScreenSize = (
    screen: ScaledSize,
    window: ScaledSize,
) => {
    if (Platform.OS === "web") return window
    else if (Platform.OS === "android") return window
    else if (isSafari) return window
    else return screen
}

interface ScreenSizes {
    screen: ScaledSize
    window: ScaledSize
}

export const useScreenDimensions = () => {
    const initialScreenData = Dimensions.get(getPlatformSpecificScreen())
    const [screenData, setScreenData] = useState(initialScreenData)

    // app state
    const {
        appState: { embeddedState },
    } = useContext(AppContext)

    useEffect(() => {
        const onChange = ({ screen, window }: ScreenSizes) => {
            const size = getPlatformSpecificScreenSize(screen, window)
            setScreenData(size)
        }

        const subscription = Dimensions.addEventListener("change", onChange)

        return () => subscription.remove()
    }, [])

    return {
        ...screenData,
        isLandscape: screenData.width > screenData.height,
        isMobileView: Platform.OS === "web" && screenData.width < 600,
        isSdkWebDesktop: embeddedState === EmbeddedState.SDK_WEB_DESKTOP,
    }
}
